module.exports = __webpack_public_path__ + "static/fictionGif-66a8f3937feb848cdb50d31c09ee67b2.mp4";